import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  
  try {
    // If icon is passed as a string (e.g., "FiTarget"), look it up in the library
    if (typeof icon === 'string') {
      IconComponent = FiIcons[icon];
    } 
    // If name is passed (e.g., "Target"), append "Fi" and look it up
    else if (name) {
      IconComponent = FiIcons[`Fi${name}`];
    } 
    // Otherwise, assume it's already an imported component
    else {
      IconComponent = icon;
    }
  } catch (e) {
    IconComponent = null;
  } 
  
  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;